<template>
  <div class="text-center">
    <v-dialog v-model="loader" persistent width="400" max-width="90vw">
      <v-card color="primary" dark>
        <v-card-text>
          Please stand by
          <v-progress-linear
            indeterminate
            color="white"
            height="6"
            class="mb-0 mt-2"
          ></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import LoaderModal from "./index";
export default {
  data() {
    return {
      loader: false,
    };
  },
  beforeMount() {
    LoaderModal.EventBus.$on("show", () => {
      this.loader = true;
    });
    LoaderModal.EventBus.$on("hide", () => {
      this.loader = false;
    });
  },
};
</script>

<style lang="scss" scoped>
.v-card {
  min-height: 90px;
}
.v-card__text {
  padding-top: 20px !important;
  font-size: 20px !important;
  font-weight: 500;
  line-height: 1.4;
}
</style>
